export default {
      id: "place-marker-usage",
      viewBox: "0 0 11.186 15.972",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#place-marker",
      toString: function () {
        return this.url;
      }
    }